// extracted by mini-css-extract-plugin
export default {"category":"index_category__TG4Ld","active":"index_active__aa1Gq","scriptsGrid":"index_scriptsGrid__f3S54","scriptDetails":"index_scriptDetails__r8LED"};